import { Form, Formik } from "formik"

import { IFormikActions } from "@redux/helper/actions"

import { DisplayModeFormButtons } from "./FormButtonArea"
import FormButtonsAndGeneralErrorArea from "./FormButtonsAndGeneralErrorArea"

interface IProps {
  submitButtonLabel?: string
  errorPrefix?: string
  submitButtonDisabled?: boolean
  /** value will always be an empty object, b/c no fields/values exists in the form */
  onSubmit: (value: ConfirmationFormSubmitType, actions: IFormikActions) => void
  onCancel?: () => void
  onReset?: () => void
  displayMode?: DisplayModeFormButtons
}

/** special return value of a ConfirmationForm: an empty object */
export type ConfirmationFormSubmitType = Record<string, never>

/**
 * This component is used for updating small changes like adding a workpackage or projectpartner.
 * It is either directly used in pages or as a modal (e.g. ConfirmModal).
 */
const ConfirmationForm: React.FC<IProps> = (props: IProps) => {
  const {
    submitButtonLabel = "form.confirm",
    errorPrefix,
    submitButtonDisabled = false,
    onSubmit,
    onCancel,
    onReset,
    displayMode = DisplayModeFormButtons.IconAndTitle
  } = props

  return <Formik<ConfirmationFormSubmitType> initialValues={{}} onSubmit={onSubmit}>
    {({
      errors,
      handleSubmit,
      isSubmitting,
      isValidating
    }) => <Form onSubmit={handleSubmit}>
        <FormButtonsAndGeneralErrorArea
          errors={errors}
          translationPrefixOnNestedErrors={errorPrefix}
          isSubmitting={isSubmitting}
          isValidating={isValidating}
          submitButton={{
            title: submitButtonLabel,
            disabled: submitButtonDisabled,
            displayMode,
          }}
          cancelButton={onCancel && { onClick: onCancel }}
          resetButton={onReset && { onClick: onReset }}
        />
      </Form>
    }
  </Formik>
}

export default ConfirmationForm
